import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { horoscopeFetchData } from '../../../redux/actions/horoscopeAction';
import { homePrimaryFetchData } from '../../../redux/actions/homePrimaryAction';
import './RashifalPage.css';

const RashifalPage = () => {
    const dispatch = useDispatch();

    let navigate = useNavigate();
    // Data from Redux
    const Horoscope = useSelector((state) => state?.HoroscopeReducer?.data);
    const { 21: assetbaseUrl } = useSelector((state) => state?.SettingReducer?.data || {});

    // State for featured/active pick
    const [activeSign, setActiveSign] = useState(null);

    useEffect(() => {
        dispatch(homePrimaryFetchData());
        dispatch(horoscopeFetchData());
    }, [dispatch]);

    useEffect(() => {
        if (Horoscope && Horoscope.length > 0) {
            setActiveSign(Horoscope[4] || Horoscope[0]); 
        }
    }, [Horoscope]);

    const handleSignClick = (sign) => {
        setActiveSign(sign);
        navigate(`/astrology/${sign?.url}/daily`);
    };

    const handleTarotClick = (sign) => {
        navigate(`/astrology/${sign?.url}/tarot`);        
    };

    const handleNumerologyClick = (num) => {
        navigate(`/astrology/${num}`);
    };

    return (
        <div className="rashifal-premium-page">
            <div className="astro-container">
                                              
                {/* Grid Design Layout */}
                <div className="astro-dashboard-grid">
                    
                    {/* Column 1: Rashifal Grid */}
                    <section className="astro-section">
                        <div className="section-title-wrap">
                            <span className="dot-indicator"></span>
                            <h2 className="section-title">રાશિફળ <span className="title-en">Rashifal</span></h2>
                        </div>
                        
                        <div className="astro-card-main">
                            <div className="zodiac-grid">
                                {Horoscope?.Astrology?.map((sign, idx) => (
                                    <div 
                                        key={idx}
                                        onClick={() => handleSignClick(sign)}
                                        className={`zodiac-item ${activeSign?.name_guj === sign.name_guj }`}
                                    >
                                        <div className="zodiac-img-wrap">
                                            <img 
                                                src={`${assetbaseUrl?.value}${sign.media}`} 
                                                alt={sign.name_guj}
                                            />
                                        </div>
                                        <span className="zodiac-name">{sign.name_guj}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>

                    {/* Column 2: Taro Insights List */}
                    <section className="astro-section">
                        <div className="section-title-wrap">
                            <span className="dot-indicator"></span>
                            <h2 className="section-title">ટેરો રાશિફળ <span className="title-en">Tarot</span></h2>
                        </div>
                        
                        <div className="astro-card-main">
                            <div className="zodiac-grid">
                                {Horoscope?.Tarot?.map((sign, idx) => (
                                    <div 
                                        key={idx}
                                        onClick={() => handleTarotClick(sign)}
                                        className={`zodiac-item ${activeSign?.name_guj === sign.name_guj }`}
                                    >
                                        <div className="zodiac-img-wrap">
                                            <img 
                                                src={`${assetbaseUrl?.value}${sign.media}`} 
                                                alt={sign.name_guj}
                                            />
                                        </div>
                                        <span className="zodiac-name">{sign.name_guj}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>

                    {/* Column 3: Numerology Matrix */}
                    <section className="astro-section">
                        <div className="section-title-wrap">
                            <span className="dot-indicator"></span>
                            <h2 className="section-title">અંક ભવિષ્ય <span className="title-en">Numerology</span></h2>
                        </div>
                        <div className="astro-card-main">
                            <div className="zodiac-grid">
                                {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                                    <div 
                                        key={num}
                                        onClick={() => handleNumerologyClick(num)}
                                        className="zodiac-item"
                                    >
                                        <div className="number-box">
                                            {num}
                                        </div>
                                        <span className="zodiac-name">અંક {num}</span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </section>
                </div>            
            </div>
        </div>
    );
};

export default RashifalPage;
